// src/stages/stage1Plant/fern/FernGroup.jsx
import React from "react";
import Fern from "./Fern.jsx";
import fernFamilyData from "./fernFamilyData.js";

export default function FernGroup({ openAmount = 1, windStrength = 0 }) {
  return (
    <>
      {fernFamilyData.map((fern) => (
        <Fern
          key={fern.id}
          position={fern.position}
          rotation={fern.rotation}
          scale={fern.scale}
          isMain={fern.isMain}
          openAmount={openAmount}
          windStrength={windStrength}
        />
      ))}
    </>
  );
}